import createItems from "./js/createitems" 
import artist from "./artist.json"
const listRef = document.querySelector(".list")
listRef.innerHTML = createItems(artist)

